import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ConfiguracionCanalFlujoVentaPasoControlProducto } from '../_models/configuracion-canal-flujo-venta-paso-control-producto';
import {ConfiguracionCanalFlujoVentaPasoPoliticaProducto} from '../_models/configuracion-canal-flujo-venta-paso-politica-producto';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionCanalFlujoVentaPasoPoliticaProductoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/configuracionesCanalesFVPasosPoliticasProductos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ConfiguracionCanalFlujoVentaPasoPoliticaProducto[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ConfiguracionCanalFlujoVentaPasoPoliticaProducto[] ) );
  }

  listadoPorIdConfiguracionCanalPaso( idConfigCanalFlujoVentaPaso: string ) {
    return this.httClient.get( this.rutServicio + '/configuracionCanalFlujoVentaPaso/' + idConfigCanalFlujoVentaPaso ).pipe( map( res => res as ConfiguracionCanalFlujoVentaPasoPoliticaProducto[] ) );
  }

  listadoHabilitadosPorIdConfiguracionCanalPaso( idConfigCanalFlujoVentaPaso: string ) {
    return this.httClient.get( this.rutServicio + '/configuracionCanalFlujoVentaPaso/' + idConfigCanalFlujoVentaPaso + '/enabled' ).pipe( map( res => res as ConfiguracionCanalFlujoVentaPasoPoliticaProducto[] ) );
  }

  listadoHabilitadoPorFlujoPasoYProductoHabilitado( idConfigCanalFlujoVentaPaso: string, idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/configuracionCanalFlujoVentaPaso/' + idConfigCanalFlujoVentaPaso + '/producto/' + idProducto + '/enabled' ).pipe( map( res => res as ConfiguracionCanalFlujoVentaPasoPoliticaProducto[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ConfiguracionCanalFlujoVentaPasoPoliticaProducto ) );
  }


  crear( regCrear: ConfiguracionCanalFlujoVentaPasoPoliticaProducto ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ConfiguracionCanalFlujoVentaPasoPoliticaProducto ) );
  }

  actualizar( regActualizar: ConfiguracionCanalFlujoVentaPasoPoliticaProducto ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regCrear: ConfiguracionCanalFlujoVentaPasoPoliticaProducto[] ) {
    const auditUser = this.autServicio.obtenerIdUsuarioLogueado();
    regCrear.forEach( pc => {
      pc.auditoriaUsuario = auditUser;
    });
    return this.httClient.post( this.rutServicio + '/bulk', regCrear ).pipe( map( res => res as ConfiguracionCanalFlujoVentaPasoPoliticaProducto[] ) );
  }
}
